export const defaultState = {
  year: '',
  newAdded: '',
  renewAdded: '',
  levelDomain: '',
};

const SET_EDIT_DATA = 'SET_EDIT_DATA';
const UPDATE_FIELD = 'updateField';

export const setEditDataCreator = (payload) => ({ type: SET_EDIT_DATA, payload });
export const updateFieldCreator = ({ name, value }) => ({ type: UPDATE_FIELD, payload: { name, value } });

const reducer = (state = defaultState, action) => {
  if (action.type === SET_EDIT_DATA) {
    return {
      ...state,
      ...action.payload,
      year: action.payload.year,
      newAdded: action.payload.newAdded,
      renewAdded: action.payload.renewAdded,
      levelDomain: action.payload.levelDomain?.id,
    };
  }
  if (action.type === UPDATE_FIELD) {
    return { ...state, [action.payload.name]: action.payload.value };
  }
  return state;
};

export default reducer; 